import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'label']
  static values = {
    url: String,
    whatsappUrl: String
  }

  connect () {
    this.onDocumentClick = (event) => {
      if (!this.element.contains(event.target)) this.closeMenu()
    }
  }

  disconnect () {
    document.removeEventListener('click', this.onDocumentClick)
  }

  toggleMenu (event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget

    if (this.menuTarget.hidden) {
      this.openMenu(button)
      return
    }

    this.closeMenu(button)
  }

  openMenu (button = this.element.querySelector('.feed-rail-btn--share')) {
    this.menuTarget.hidden = false
    if (button) button.setAttribute('aria-expanded', 'true')
    document.addEventListener('click', this.onDocumentClick)
  }

  closeMenu (button = this.element.querySelector('.feed-rail-btn--share')) {
    if (this.hasMenuTarget) this.menuTarget.hidden = true
    if (button) button.setAttribute('aria-expanded', 'false')
    document.removeEventListener('click', this.onDocumentClick)
  }

  async copyLink (event) {
    event.preventDefault()
    event.stopPropagation()

    const url = this.urlValue
    if (!url) return

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url)
      } else {
        this.legacyCopy(url)
      }
      this.flashLabel('Copied!')
    } catch (_) {
      this.flashLabel('Copy failed')
    }

    this.closeMenu()
  }

  shareWhatsApp (event) {
    event.preventDefault()
    event.stopPropagation()

    const url = this.whatsappUrlValue
    if (url) window.open(url, '_blank', 'noopener,noreferrer')

    this.closeMenu()
  }

  legacyCopy (value) {
    const input = document.createElement('textarea')
    input.value = value
    input.setAttribute('readonly', '')
    input.style.position = 'absolute'
    input.style.left = '-9999px'
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
  }

  flashLabel (text) {
    if (!this.hasLabelTarget) return

    const original = this.labelTarget.textContent
    this.labelTarget.textContent = text
    window.setTimeout(() => {
      this.labelTarget.textContent = original
    }, 1600)
  }
}
